import React, { Component } from 'react';
import { StyleSheet, View, Text, TouchableOpacity, Linking, Image } from 'react-native';
import images from "../../images/ImagesControl";

class Chapter2 extends Component {
    render() {
        return (
            <View style={styles.container}>
                <Text style={styles.heading}>
                    {
                        "Getting Started"
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "It is simple enough for third parties to access M18 through provided WS. " +
                        "The followings are the only two things you have to prepare before start."
                    }
                </Text>
                <Text style={[styles.text, { paddingLeft: 20 }]}>
                    {
                        "1.	Authenticate your Application in M18. OAuth2.0 protocol is provided for authentication."
                    }
                </Text>
                <Text style={{ paddingLeft: 50 }}>
                    {
                        "Detail: "
                    }
                    <TouchableOpacity onPress={() => Linking.openURL('http://m18doc.multiable.com/en/m18/m18wsauth')}>
                        <View>
                            <Text style={styles.hyperlink}>
                                {
                                    "http://m18doc.multiable.com/en/m18/m18wsauth"
                                }
                            </Text>
                        </View>
                    </TouchableOpacity>
                </Text>
                <Text style={[styles.text, { paddingLeft: 20 }]}>
                    {
                        "2.	Complete Business Entity Setup."
                    }
                </Text>
                <View style={{ paddingLeft: 50 }}>
                    <Text>
                        {
                            "Tips 1: Go to the module you would like to access, a pop up message box will guide you what to be configured."
                        }
                    </Text>
                    <Image source={images.ch2_fig1} style={{ width: 330, height: 200 }} />
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        width: 700,
    },
    heading: {
        paddingTop: 20,
        fontSize: 30,
        fontWeight: 'bold',
    },
    text: {
        paddingTop: 20,
    },
    hyperlink: {
        fontStyle: 'iTalic',
        color: 'blue',
        textDecorationLine: 'underline',
    },
});

export default Chapter2;



// WEBPACK FOOTER //
// ./src/pages/ch2/Chapter2.js